import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { ProductDirective } from './product.directive';
/**
 * Product component ng module.
 */
export var ProductComponentNgModule = module(baseModuleId + ".product", [])
    .directive('product', ProductDirective);
